import V from 'voca';
import ExpandableTextComponent from '72cms-ui/components/form-elements/ExpandableTextComponent';

export default {
    sections: ['details', 'image', 'meta data'],
    groups: {
        staff_details: {
            component: {
                template: `<div class="form-row">
                    <slot name="firstname" />
                    <slot name="lastname" />
                    <slot name="title" />
                </div>`
            }
        }
    },
    toolbar: ['add', 'edit', 'active', 'delete'],
    fields: {
        firstname: {
            section: 'details',
            group: 'staff_details',
            cssClass: 'col-md-4',
            position: 1,
        },
        lastname: {
            section: 'details',
            group: 'staff_details',
            cssClass: 'col-md-4',
            position: 1.1,
        },
        title: {
            section: 'details',
            group: 'staff_details',
            cssClass: 'col-md-4',
            position: 2,
        },
        intro: {
            section: 'details',
            component: ExpandableTextComponent,
            position: 4,
        },
        content: {
            section: 'details',
            position: 5,
        },
        image: {
            section: 'image',
            position: 0,
            description: 'Please resize images to 161px x 264px prior to uploading. The filesize of your image should not exceed <strong>200k</strong>',
        },

        name_id: {
            label: 'Page URL',
            section: 'meta data',
            position: 2,
            description: 'This field will be populated based on page name if left blank',
            prefix: '/staff/',
            listener: function (entry, entries, $form) {
                if (['firstname', 'lastname'].indexOf(entry.name) >= 0 && entry.newValue && !this.value) {
                    const firstname = _.chain(entries).find((e) => e.name == 'firstname').get('value', null).value();
                    const lastname = _.chain(entries).find((e) => e.name == 'lastname').get('value', null).value();
                    this.value = _.chain([firstname, lastname]).filter().join(' ').thru(V.slugify).value();
                }
            }
        },

        meta_description: {
            section: 'meta data',
            position: 3,
            component: ExpandableTextComponent,
        },

        meta_keywords: {
            section: 'meta data',
            position: 4,
            component: ExpandableTextComponent,
        },
    }
}




// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/form.staff_member.js